export const ROLE = {
  SUPER: "super_admin",
  CLIENT_ADMIN: "client_admin",
  SERVICE_ADMIN: "service_admin",
  CLIENT_USER: "client_user",
  SERVICE_USER: "service_user",
};

export function normalizeRole(rawRole) {
  const r = String(rawRole || "").trim();

  // backward compatibility
  if (r === "superadmin") return ROLE.SUPER;
  if (r === "admin") return ROLE.SUPER;
  if (r === "service") return ROLE.SERVICE_USER;
  if (r === "client") return ROLE.CLIENT_USER;

  if (Object.values(ROLE).includes(r)) return r;

  return null;
}

export function normalizeStatus(rawStatus) {
  const s = String(rawStatus || "").trim();

  // backward compatibility
  if (s === "rejected") return "denied";

  if (["pending", "approved", "active", "denied"].includes(s)) return s;

  return null;
}

export function isApproved(userStatus) {
  const status = normalizeStatus(userStatus);
  return status === "approved" || status === "active";
}

// ----- capabilities -----

export function canDownloadFirmware(userStatus, userRole) {
  if (!isApproved(userStatus)) return false;
  const role = normalizeRole(userRole);
  if (!role) return false;

  return [ROLE.SUPER, ROLE.SERVICE_ADMIN, ROLE.SERVICE_USER].includes(role);
}

export function canManageFirmware(userStatus, userRole) {
  if (!isApproved(userStatus)) return false;
  const role = normalizeRole(userRole);
  if (!role) return false;

  return [ROLE.SUPER, ROLE.SERVICE_ADMIN].includes(role);
}

export function canDownloadClientDocs(userStatus, userRole) {
  if (!isApproved(userStatus)) return false;
  const role = normalizeRole(userRole);
  if (!role) return false;

  return [ROLE.SUPER, ROLE.CLIENT_ADMIN, ROLE.CLIENT_USER].includes(role);
}

export function canManageClients(userStatus, userRole) {
  if (!isApproved(userStatus)) return false;
  const role = normalizeRole(userRole);
  if (!role) return false;

  return [ROLE.SUPER, ROLE.CLIENT_ADMIN].includes(role);
}
